import {
  Alert as DSAlert,
  MaterialUICore,
  axiomTokens,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing } = axiomTokens;

export const Alert = styled(DSAlert)({
  display: 'flex',
  padding: `${spacing[2]} ${spacing[4]}`,

  '& .MuiSnackbarContent-message': {
    gap: spacing[2],
  },

  '& .MuiSnackbarContent-action': {
    marginTop: 0,
  },
});
